export const normalizePaymentStatusKey = (status) =>
  String(status || '')
    .toLowerCase()
    .replace(/[\s_-]/g, '');

export const getPaymentStatusMeta = (status) => {
  const key = normalizePaymentStatusKey(status);

  if (key === 'paid') {
    return { label: 'Paid', className: 'paid' };
  }
  if (key === 'partiallypaid') {
    return { label: 'Partially Paid', className: 'partial' };
  }
  if (key === 'unpaid' || key === 'sent') {
    return { label: 'Unpaid', className: 'unpaid' };
  }

  return { label: status || 'Unpaid', className: 'unpaid' };
};

/** Payment column is money status only — emailed invoices stay Unpaid until paid. */
export const getInvoiceDisplayStatusMeta = (invoice) =>
  getPaymentStatusMeta(invoice?.paymentStatus);
